import { isEmpty, isString } from "lodash-es";
import { API_BASE_URL } from "./constants";

const joinPath = (...args) => {
  const parts = args.map((arg, index) => {
    if (arg.endsWith('/')) {
      return arg.slice(0, -1);
    }
    if (index > 0 && arg.startsWith('/')) {
      return arg.slice(1);
    }
    return arg;
  });
  return parts.join('/');
};


const getQualifiedImageUrl = (srcUrl) => {
  let url = srcUrl;
  if (isString(url) && !isEmpty(url)) {
    const isExternalImage = url.startsWith('http') || url.startsWith('//') || url.startsWith('www');
    const isEmbeddedImage =
      !isExternalImage && (url.startsWith('/assets/') || url.startsWith('assets/'));

    if (!isExternalImage && !isEmbeddedImage) {
      url = joinPath(API_BASE_URL, url);
    } else if (isEmbeddedImage && url.startsWith('assets/')) {
      url = `/${url}`;
    }
  }
  return url;
};

export default getQualifiedImageUrl;
